<template>
  <footer>
    <p>Created by Søren Winkel Holm, Anders Henriksen, Oskar Wiese</p>
  </footer>
</template>

<style lang="scss">
  footer {
    p {
    font-size: 0.75em
    }
  }
</style>
